import { defineMessages } from 'react-intl';

export default defineMessages({
  'header_hotkey_template' : {
    'id' : 'admin.hotkey_template.header.hotkey_template',
    'defaultMessage' : 'Hotkey Template'
  },
  'header_item' : {
    'id' : 'admin.hotkey_template.header.item',
    'defaultMessage' : 'Item'
  },
  'header_group' : {
    'id' : 'admin.hotkey_template.header.group',
    'defaultMessage' : 'Group'
  },


  'label_active' : {
    'id' : 'admin.hotkey_template.form.active',
    'defaultMessage' : 'Active'
  },
  'label_name' : {
    'id' : 'admin.hotkey_template.form.name',
    'defaultMessage' : 'Name'
  },
  'label_image_url' : {
    'id' : 'admin.hotkey_template.form.image_url',
    'defaultMessage' : 'Image URL'
  },
  'label_new' : {
    'id' : 'admin.hotkey_template.form.new',
    'defaultMessage' : 'New'
  },
  'label_add_new' : {
    'id' : 'admin.hotkey_template.form.add_new',
    'defaultMessage' : 'Add new'
  },
  'label_type' : {
    'id' : 'admin.hotkey_template.form.type',
    'defaultMessage' : 'Type'
  },
  'label_classification' : {
    'id' : 'admin.hotkey_template.form.classification',
    'defaultMessage' : 'Classification'
  },
  'label_items' : {
    'id' : 'admin.hotkey_template.form.items',
    'defaultMessage' : 'Items'
  },
  'label_item' : {
    'id' : 'admin.hotkey_template.form.item',
    'defaultMessage' : 'Item'
  },
  'label_add' : {
    'id' : 'admin.hotkey_template.form.add',
    'defaultMessage' : 'Add'
  },
});